export default __webpack_public_path__ + "static/media/logo_footer_inflo.ff8ab8db.png";